import React, { useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/js/all";
import "./App.scss";
import muiTheme from "./theme";
import godown from "./assets/images/godown.gif";
import loadingGIF from "./assets/images/loading.gif";

// import { PacmanLoader } from 'react-spinners';
import { MuiThemeProvider } from "@material-ui/core/styles";
import {
  Grid,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Breadcrumbs,
  Typography,
  Link,
} from "@material-ui/core";
import MainBody from "./Main/MainBody";

const aboutData = [
  {
    item: "Instructor",
    text: "Behrooz Nasihatkon",
    textLink: "https://wp.kntu.ac.ir/nasihatkon",
    icon: "fas fa-chalkboard-teacher",
    imageSrc: "./assets/avatar/behrooz-nasihatkon.jpg",
    hr: true,
    full: true,
  },
  {
    item: "Head Teaching Assistant",
    text: "Alireza Kavian",
    textLink: "https://alireza-kavian.github.io",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/alireza-kavian.jpg",
    full: true,
  },
  {
    item: "Teaching Assistant",
    text: "Amirhossein Mashghdoust",
    textLink: "https://www.linkedin.com/mwlite/in/amirhosein-m-21172521a",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/amirhossein-mashghdoust.jpg",
  },
  {
    item: "Teaching Assistant",
    text: "Shekoufeh Sadeghi",
    textLink: "https://www.linkedin.com/in/shekoufeh-sadeghi-45100a1ba/",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/shekoufeh-sadeghi.jpg",
  },
  {
    item: "Teaching Assistant",
    text: "Ali Salimian",
    textLink: "https://www.linkedin.com/in/alisalimian/",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/ali-salimian.jpg",
  },
  {
    item: "Teaching Assistant",
    text: "Matin Saedi",
    textLink: "https://www.linkedin.com/in/matin-saedi-407525220",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/matin-saedi.jpg",
  },
  {
    item: "Teaching Assistant",
    text: "Fatemeh Kashanian",
    textLink: "http://linkedin.com/in/fatemeh-kashanian",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/fatemeh-kashanian.jpg",
  },
  {
    item: "Teaching Assistant",
    text: "Mina Naseh",
    textLink: "https://www.linkedin.com/in/mina-naseh/",
    icon: "fas fa-user-graduate",
    imageSrc: "./assets/avatar/mina-naseh.jpg",
  },
];

const contactData = [
  {
    item: "Quera",
    text: "Goto Class",
    textLink: "https://quera.ir/overview/add_to_course/course/9210",
    icon: "fab fa-quora",
  },
  {
    item: "Telegram",
    text: "Goto Channel",
    textLink: "https://t.me/joinchat/IikjayqYDfJmNjU0",
    icon: "fab fa-telegram-plane",
  },
];

const loading = (setLoad) => (
  <div id="loading" onClick={() => setLoad(false)}>
    <div className="text">
      <h1>Linear Algebra Course</h1>
      <h2>Fall 2021</h2>
      <h3>Behrooz Nasihatkon</h3>
      <u>
        <small>click anywhere to continue</small>
      </u>
    </div>
    <div className="animated">
      <img alt="" src={loadingGIF} />
    </div>
  </div>
);

const about = () => (
  <List className="about">
    <Grid container>
      {(aboutData || []).map((el) => (
        <Grid key={el.text} lg={el.full ? 12 : 6}>
          <ListItem>
            <ListItemAvatar>
              {!el.imageSrc && (
                <Avatar className="avatar">
                  <i className={`${el.icon} fa-lg icon`} />
                </Avatar>
              )}
              {el.imageSrc && (
                <Avatar className="avatar" src={el.imageSrc} alt={el.text} />
              )}
            </ListItemAvatar>
            <ListItemText
              className="text"
              primary={
                <a target="_blank" rel="noopener noreferrer" href={el.textLink}>
                  {el.text}
                </a>
              }
              secondary={el.item}
            />
          </ListItem>
          {el.hr && <Divider className="divider" />}
        </Grid>
      ))}
    </Grid>
  </List>
);

const contact = () => (
  <List className="contact">
    {(contactData || []).map((el) => (
      <ListItem key={el.text}>
        <ListItemAvatar>
          {!el.imageSrc && (
            <Avatar className="avatar">
              <i className={`${el.icon} icon`} />
            </Avatar>
          )}
          {el.imageSrc && (
            <Avatar className="avatar" src={el.imageSrc} alt={el.text} />
          )}
        </ListItemAvatar>
        <ListItemText
          className="text"
          primary={
            <a target="_blank" rel="noopener noreferrer" href={el.textLink}>
              {el.text}
            </a>
          }
          secondary={el.item}
        />
      </ListItem>
    ))}
  </List>
);

const breadCrumb = () => (
  <Breadcrumbs separator="›" aria-label="breadcrumb">
    <Link color="inherit" href="../../">
      All Courses
    </Link>
    <Link color="inherit" href="../">
      LA Course (UG)
    </Link>
    <Typography color="textSecondary">LA Autumn 2021</Typography>
  </Breadcrumbs>
);

function App() {
  const [load, setLoad] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoad(false);
    }, 10000);
    window.scrollTo(0, 0);
  }, []);
  return (
    <MuiThemeProvider theme={muiTheme}>
      <div className="App">
        {load && loading(setLoad)}
        <header className="App-header">
          <span id="godown">
            <img src={godown} alt="\/" />
          </span>
          <Grid container className="header-wrapper" spacing={2}>
            <Grid className="left" item xs={12} md={5}>
              <div className="bread-crumb">{breadCrumb()}</div>
              <h1>
                Linear Algebra for Computer Science and Engineering
                <small style={{ display: "block", marginTop: 11 }}>(Fall 2021)</small>
              </h1>
              <div className="contact-parent">{contact()}</div>
            </Grid>
            <Grid className="right" item xs={12} md={7}>
              {about()}
            </Grid>
          </Grid>
        </header>
        <main id="main" className="App-main">
          <MainBody />
        </main>
        <footer className="App-footer">
          <bdi>Behrooz Nasihatkon © 2021 All rights reserved.</bdi>
          <div>
            Powered by{" "}
            <a href="https://alireza-kavian.github.io">Alireza Kavian</a>
          </div>
        </footer>
      </div>
    </MuiThemeProvider>
  );
}

export default App;
